import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import spread from "../../images/svg/spread.svg";
import { getUyeItemData } from "../../features/uyelerAraclar/uyelerAraclarSlice";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { getUETDSItemData, sendUETDS } from "../../features/admin/adminSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  border-radius: 10px;
    .content-container {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      /* border: 1px solid ;
      border-color:  ${({ theme }) => theme.mainBorderColor}; */
      .row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        cursor: pointer;
        .error{
          color: var(--color-main);
          margin-left: 5px;
          font-weight: var(--font-weight-md);
          font-size: var(--font-size-md);
        }
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          flex: 1;
          text-align: center !important;
          color: ${({ theme }) => theme.mainTextColor};

          .is-danger{
            background-color: var(--color-main);
            border-radius: 50%;
            color: #fff;
            width: 30px !important;
            height: 30px !important;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }

        .col-sm{
          flex: .3 !important;
        }

      }
    }
  .btn {
    color: var(--color-main) !important;
    border: 1px solid var(--color-main);
    padding: 6px 10px;
    border-radius: 8px;
  }
`;

const UetdsContainer = ({ data, isGonderilmis }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  const gonderilmisDetay = () => {
    if(isGonderilmis === "Gönderilmiş"){
      dispatch(showModal("uetdsGonderilmisDetay")) 
      dispatch(getUETDSItemData(data))
    }
  } 

  return (
    <Container>
      <div onClick={gonderilmisDetay} className="container">
        <div className="content-container">
          <div onClick={() => {!data.isEgeApproved && dispatch(getUETDSItemData(data)); !data.isEgeApproved && dispatch(showModal("updateUETDS")); }} className="row">
            <div className="col">{data.user?.phoneNumber}</div>
            <div className="col">{data.user.adSoyadUnvan}</div>
            <div className="col">{data?.tcKimlikNo1}{data?.tcKimlikNo1?.length !== 11 && <span className="error">!</span>}</div>
            <div className="col">{data.plaka1}</div>
            <div className="col">{data.yuklemeTarihi}-{data.yuklemeSaati}</div>
            <div className="col">{data.bosaltmaTarihi}-{data.bosaltmaSaati}</div>
            <div className="col">{data.yuklemeIlAdi}/{data.yuklemeIlceAdı.charAt(0).toUpperCase() + data.yuklemeIlceAdı.slice(1).toLowerCase()}</div>
            <div className="col">{data.bosaltmaIlAdi}/{data.bosaltmaIlceAdı.charAt(0).toUpperCase() + data.bosaltmaIlceAdı.slice(1).toLowerCase()}</div>
            <div className="col col-sm">{data.yukMiktarı}-{data.yukBirimi}</div>
            <div className={data.tasimaTuruKodu ? "col col-sm danger" : "col col-sm"}>
              <div className={data.tasimaTuruKodu === 1 && "is-danger"}>{data.tasimaTuruKodu === 2 ? "N" : "T"}</div>
            </div>
            {data.isEgeApproved === false ?
              (data.tasimaTuruKodu === 1 ?
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  !data.isEgeApproved && dispatch(sendUETDS(data.id));
                  // !data.isEgeApproved && setSendingProcessedId(data.id);
                }}
                className="col col-sm btn"
              >
                Gönder
              </div>
              : "---")
              :
              <div className="col col-sm">
                Gönderildi
              </div>
            }
            
          </div>
        </div>
      </div>
    </Container>
  );
};

export default UetdsContainer;
